/**
 * PUBLIC route for the teacher page (guest-first, no account):
 * `/teachers/<orgSlug>/<slug>` lives OUTSIDE the `/u/<n>` tree (like
 * `/verify/<certId>`) because the link is shared outside the app — a
 * visitor has no reason to have a session. Consumes the public REST
 * `/api/public/teachers/:orgSlug/:slug`.
 */
import { createRoute, useParams } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { PublicTeacherPageView } from "@/features/academy/components/people/public-teacher-page";
// B8 · academy assistant: it's the surface where leads without an
// account really are. The endpoint is public and its own flag turns it off; the widget doesn't
// appear if the academy hasn't turned it on (the server returns 403 and the widget
// stays silent).
import { AcademyBotWidget } from "@/features/academy-bot/chat-widget";

function PublicTeacherPage() {
  const params = useParams({ from: "/teachers/$orgSlug/$slug" });
  return (
    <>
      <PublicTeacherPageView orgSlug={params().orgSlug} slug={params().slug} />
      <AcademyBotWidget orgSlug={params().orgSlug} />
    </>
  );
}

export const publicTeacherRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/teachers/$orgSlug/$slug",
  component: PublicTeacherPage,
});
